function usercentricsGlobal() {
  usercentrics.updateLanguage(document.documentElement.lang)
}

window['usercentrics'] = window['usercentrics'] || {}
if (window['usercentrics'].isInitialized) {
  usercentricsGlobal()
} else {
  usercentrics.onViewInit = function () {
    usercentricsGlobal()
  }
}



// WEBPACK FOOTER //
// ./js/parts/usercentrics.js